<template>
  <div class="wrap">
    <!-- 个人头部信息 -->
    <div class="header-info-contaniner">
      <div class="avatar-x">
        <img class="avatar" :src="info.avatar" alt="头像" />
      </div>
      <div class="info-x">
        <div class="username">{{ info.username }}</div>
        <div class="department">{{ info.department }}</div>
      </div>
    </div>

    <!-- 列表区域 -->
    <div class="salary-li">
      <div class="year-salary-ul" v-for="(item, index) in list" :key="index">
        <div class="year-title">{{ item.title }}</div>
        <div class="month-salary-ul" v-for="(item1, index1) in item.children" :key="index1" @click="goUrl(item1.id)">
          <van-row class="month-salary" type="flex">
            <van-row :span="24" type="flex" justify="space-between">
              <div class="title">{{ item1.title }}</div>
              <div class="salary">{{ item1.salary }}</div>
            </van-row>
            <van-row :span="24" type="flex" justify="space-between">
              <div class="time">{{ item1.time }}</div>
              <div class="describe">{{ item1.describe }}</div>
            </van-row>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {
        avatar: "",
        username: "",
        department: "",
      },
      list: [
        // {
        //   title: "0000年",
        //   children: [{ id: 0, title: "XX月工资单", describe: "实发金额", salary: "￥0.00", time: "" }],
        // },
      ],
    };
  },
  methods: {
    // 跳转至详细
    goUrl(id) {
      this.$router.push("/payroll/" + id);
    },
    async init() {
      let { data } = await this.$post(this.$api.stGetSalaryList);
      this.info = data.info;
      this.list = data.list;
      if (this.list.length == 0) {
        this.$toast("暂无工资记录");
      }
    },
  },
  mounted() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "工资单" });
    });
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  background-color: #f3f3f3;
}
.header-info-contaniner {
  box-sizing: border-box;
  display: flex;
  padding: 40px;
  height: 128px;
  color: #fff;
  background-color: #2a82e4;
}

.avatar-x {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar {
  width: 100%;
  height: 100%;
}
.info-x {
  display: flex;
  margin-left: 20px;
  flex-direction: column;
  justify-content: space-around;
}
.username {
  font-size: 18px;
}
.department {
  font-size: 12px;
}
.salary-li .year-salary-ul ~ .year-salary-ul {
  margin-top: 18px;
}
.year-salary-ul {
  padding-bottom: 8px;
  background-color: #fff;
}
.year-title {
  box-sizing: border-box;
  padding: 15px;
  height: 50px;
  color: #505050;
  font-weight: bold;
  background-color: #e1e7ef;
}

.year-salary-ul .month-salary-ul ~ .month-salary-ul {
  border-top: 1px dotted #999999;
}
.month-salary-ul {
  margin: 0 15px;
}
.month-salary {
  flex-direction: column;
  margin: 8px 0px;

  .title {
    font-size: 16px;
  }

  .salary {
    font-size: 16px;
  }
  .time {
    font-size: 12px;
    color: #808080;
  }
  .describe {
    font-size: 12px;
    color: #808080;
  }
}
</style>
